<template>
  <div v-if="trackUrl" class="spotlight-embed">
    <p class="spotlight-embed-label mute font-small tt-up m-b-lg">Listen</p>
    <iframe
      v-if="isSoundCloud"
      :src="soundcloudSrc"
      width="100%"
      height="166"
      scrolling="no"
      frameborder="no"
      allow="autoplay"
      class="spotlight-iframe"
    ></iframe>
    <a v-else :href="trackUrl" target="_blank" rel="noopener noreferrer" class="mute font-small text-link">
      {{ trackUrl }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'SpotlightTrackEmbed',
  props: {
    trackUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSoundCloud() {
      return this.trackUrl && this.trackUrl.includes('soundcloud.com')
    },
    soundcloudSrc() {
      const encoded = encodeURIComponent(this.trackUrl)
      return `https://w.soundcloud.com/player/?url=${encoded}&color=%23e1ff00&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false`
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.spotlight-embed-label {
  letter-spacing: 0.1em;
}

.spotlight-iframe {
  display: block;
  border: none;
}
</style>
